import { Layout } from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import TalentMarketplace from '@/components/TalentMarketplace';
import EnhancedTalentMarketplace from '@/components/venture/EnhancedTalentMarketplace';
import { useUser } from '@/contexts/UserContext';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';
import { PageOnboardingTooltip, OnboardingSlide } from '@/components/onboarding/PageOnboardingTooltip';
import { Users, Sparkles, BarChart3, Search, Brain } from 'lucide-react';

const talentMarketplaceSlides: OnboardingSlide[] = [
  { icon: Users, secondaryIcons: [Search], title: 'Discover Talent', description: 'Browse athletes, creators, and influencers. Filter by sport, follower count, engagement rate, and more to find the perfect partner.', gradient: 'from-primary/20 to-primary/5' },
  { icon: Brain, secondaryIcons: [Sparkles], title: 'AI Recommendations', description: 'Get AI-powered talent suggestions based on your brand values, target audience, and campaign objectives. Smart matching saves you time.', gradient: 'from-blue-500/20 to-blue-500/5' },
  { icon: BarChart3, title: 'Analytics & Engagement', description: 'View detailed analytics for each talent — social reach, engagement metrics, audience demographics, and past partnership performance.', gradient: 'from-emerald-500/20 to-emerald-500/5' },
];

const TalentMarketplacePage = () => {
  const { accountType } = useUser();
  const { isMobile } = useEnhancedMobile();

  return (
    <Layout>
      <PageHeader 
        title="Talent Marketplace." 
        subtitle="Discover and analyze talent partnerships"
      />
      <div className={`container mx-auto max-w-[1200px] overflow-x-hidden ${isMobile ? 'px-2 py-2' : 'px-6 py-6'}`}>
        <PageOnboardingTooltip storageKey="talent_marketplace_tooltip_dismissed" slides={talentMarketplaceSlides} dialogTitle="Talent Marketplace Walkthrough" />
        {accountType === 'venture' || accountType === 'brand' ? (
          <EnhancedTalentMarketplace />
        ) : (
          <TalentMarketplace />
        )}
      </div>
    </Layout>
  );
};

export default TalentMarketplacePage;